import { render, staticRenderFns } from "./PpvStatsHeader.vue?vue&type=template&id=1e098c00&scoped=true"
import script from "./PpvStatsHeader.vue?vue&type=script&lang=js"
export * from "./PpvStatsHeader.vue?vue&type=script&lang=js"
import style0 from "./PpvStatsHeader.vue?vue&type=style&index=0&id=1e098c00&prod&lang=css"
import style1 from "./PpvStatsHeader.vue?vue&type=style&index=1&id=1e098c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e098c00",
  null
  
)

export default component.exports